module.exports = __webpack_public_path__ + "static/media/checkbox_empty_black.73c118ac.svg";